import CreditCardChargesList from "../../game-views/datasets/credit_card_charges_list";

export const rptMissingCreditInfo = (events) => {

let rptArr = [];
 for (let i=0; i<events.length; i++){
        if (i === 0){
            const headingLine = {
                eventTitle: "Event Title",  eventID: "eventID", description: "Description", 
                    btnText: "BtnText", itemDesc: "Item Desc", expCategory: "Expense Category", 
                    tableExpCategory: "TableExpCategory", possibleValues: "Possible Values"  };
            rptArr.push(headingLine);
        }
        const event = events[i];
        for (let j=0; j<event.responses.length; j++){
            const response = event.responses[j];
            let selectRecord = false;
            for (let k=0; k<response.possibleEffects.length; k++){
                const effect = response.possibleEffects[k];
                if (effect.on === "cash" && +effect.possibleValues[0] < 0){
                    selectRecord = true;
                }
            }
            if (selectRecord === true){
                const chargeCategory = 
                CreditCardChargesList.find(elem => elem.desc === response.itemDesc);
                let expTableCategory = "Not Found";
                if (chargeCategory){
                    expTableCategory = chargeCategory.category;
                }
                let itemDesc = "Not Found";
                if (response.itemDesc && response.itemDesc !== ""){
                    itemDesc = response.itemDesc;
                }
                let creditCategory = "Not Found";
                if (response.creditCategory && response.creditCategory !== ""){
                    creditCategory = response.creditCategory;
                }
                     
                if (!response.creditCardCategory ||
                    response.creditCardCategory === "Not Found" ||
                    (response.creditCardCategory !== expTableCategory &&
                        expTableCategory !== "Not Found" )){
                    const detailRptLine = { eventTitle: event.title, eventID: event.id,
                            description:  event.description, btnText: response.btnText, 
                            itemDesc: itemDesc, expCategory: creditCategory,
                            tableExpCategory: expTableCategory}
                    rptArr.push(detailRptLine);
                }
            }
        }
    }
    return rptArr;
         
}
export default rptMissingCreditInfo;